import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from 'modules/Auth/authReducer'

export const useAuth = () => {
  const userId = useSelector(selectCurrentUser)

  return useMemo(() => ({ userId }), [userId])
}
